"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDataFromRequest;

var _relayRuntime = require("relay-runtime");

function getDataFromRequest(_ref, environment) {
  var query = _ref.query,
      variables = _ref.variables;
  var request = (0, _relayRuntime.getRequest)(query);
  var operation = (0, _relayRuntime.createOperationDescriptor)(request, variables);
  var res = environment.lookup(operation.fragment);
  return res.data;
}